import React, { useEffect, useState } from "react";
import "./scrollTopButton.scss";
import { useLocation } from "react-router-dom";
import { CommonConstants } from "@src/define/common";
import { useThrottle } from "@src/utils/hooks/useThrottle";

const {
  DisplayScrollTopButtonPaths,
  DisplayWeddingHallQuickButtonPaths,
  DisplaySdmQuickButtonPaths,
} = CommonConstants;

export default function ScrollTopButton() {
  const location = useLocation();
  const throttle = useThrottle();

  const [isScrollOver, setIsScrollOver] = useState(false);
  const [isIncludePath, setIsIncludePath] = useState(false);
  const [isIncludeQuickButtonPage, setIsIncludeQuickButtonPage] = useState(false);

  const handleScrollBtnClick = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleScroll = throttle(() => {
    window.scrollY > 300 ? setIsScrollOver(true) : setIsScrollOver(false);
  }, 50);

  // 퀵버튼이 포함된 페이지인지 확인 - fixed 버튼 위치 조정 필요
  useEffect(() => {
    const isWeddingHallQuickButton = DisplayWeddingHallQuickButtonPaths.some((path) =>
      location.pathname.startsWith(path),
    );
    const isSdmQuickButton = DisplaySdmQuickButtonPaths.some((path) =>
      location.pathname.startsWith(path),
    );

    if (isWeddingHallQuickButton || isSdmQuickButton) {
      setIsIncludeQuickButtonPage(true);
    } else {
      setIsIncludeQuickButtonPage(false);
    }
  }, [location]);

  useEffect(() => {
    const pathName = location.pathname;

    if (DisplayScrollTopButtonPaths.some((path) => pathName.startsWith(path))) {
      setIsIncludePath(true);
      window.addEventListener("scroll", handleScroll);
    } else {
      setIsIncludePath(false);
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [location]);

  return (
    <>
      {isIncludePath && isScrollOver && (
        <button
          className={`
            scroll-top-button-wrap
            ${isIncludeQuickButtonPage ? "include-quick-button-page" : "test"}
          `}
          onClick={handleScrollBtnClick}
        >
          <i className="scroll-top-icon"></i>
        </button>
      )}
    </>
  );
}
